import l from "./index286.js";
import { createElementBlock as t, openBlock as s, normalizeClass as o, createCommentVNode as p, createElementVNode as a, renderSlot as n } from "vue";
import r from "./index231.js";
const i = ["data-component"];
function d(e, m, h, f, y, c) {
  return s(), t("span", {
    class: o([[
      {
        "bg-color-brand-beige-75": e.type === e.types.Default && !e.colorClass,
        "bg-color-alert-positive text-white": e.type === e.types.Highlight,
        "bg-black/50 text-white": e.type === e.types.Media,
        "bg-white": e.type === e.types.Recommendation,
        "px-8": !e.$slots.icon,
        "pl-8 pr-4": e.$slots.icon && e.isIconRight,
        "pr-8 pl-4": e.$slots.icon && !e.isIconRight
      },
      e.colorClass
    ], "inline-flex items-center h-24 gap-4 rounded-normal"]),
    "data-component": e.$options.name
  }, [
    e.$slots.icon ? (s(), t("span", {
      key: 0,
      class: o(["w-lh-text-desktop h-lh-text-desktop", {
        "text-color-alert-positive": e.type === e.types.Recommendation,
        "order-2": e.isIconRight
      }])
    }, [
      n(e.$slots, "icon")
    ], 2)) : p("", !0),
    a("span", {
      class: o(["text-text", {
        "font-bold": e.type !== e.types.Default
      }])
    }, [
      n(e.$slots, "default")
    ], 2)
  ], 10, i);
}
const b = /* @__PURE__ */ r(l, [["render", d]]);
export {
  b as default
};
